import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CollapsableItem } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/HistoryPanel/CollapsableItem'

interface Data {
  count: number
  details: React.ReactNode
}

interface Props {
  title: string
  loading: boolean
  data: {
    joiners: Data
    leavers: Data
    promotions: Data
  }
}

export const Content = ({ loading, title, data }: Props) => {
  if (Object.values(data).every((value) => value.count === 0)) {
    return null
  }

  return (
    <>
      <Box paddingY="s16">
        <Text.Normal size="100" weight="medium" color="textSecondary" capitalize>
          {title}
        </Text.Normal>
      </Box>

      <Box gap="s20">
        {data.joiners.count > 0 && (
          <CollapsableItem
            loading={loading}
            count={data?.joiners.count}
            type={i18n.t('finance.financial_workspace.employee_costs.workforce.types.joiners')}
            details={data?.joiners.details}
          />
        )}
        {data.leavers.count > 0 && (
          <CollapsableItem
            loading={loading}
            count={data?.leavers.count}
            type={i18n.t('finance.financial_workspace.employee_costs.workforce.types.leavers')}
            details={data?.leavers.details}
          />
        )}
        {data.promotions.count > 0 && (
          <CollapsableItem
            loading={loading}
            count={data?.promotions.count}
            type={i18n.t('finance.financial_workspace.employee_costs.workforce.types.promotions')}
            details={data?.promotions.details}
          />
        )}
      </Box>
    </>
  )
}
